export default {
  'Custom': 'Personalizado',
  'Original': 'Original',
}